import React from 'react';
import { ComponentInfo, AccountSelector } from '@components';
import { CompanyAccounts } from '@types';
import { useAccountSelectorHelper } from './accountSelector.helper';
import { useFetchDocument } from '@hooks';
import { useDidMount, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

export const AccountSelectorPlaceholder: React.FC = () => {
	const t = useTranslation();
	const { companyAccountsData } = useAccountSelectorHelper();
	const { fetchBankDocument } = useFetchDocument({
		reference: t('document.conditionsTermsBank.id'),
	});
	const { fetchSoftwareDocument } = useFetchDocument({
		reference: t('document.conditionsTermsSoftware.id'),
	});
	const companyAccounts = companyAccountsData;

	useDidMount(() => {
		// call fetch to obtaining bank and software docs
		// the objective is reduce number of show loadings
		fetchBankDocument();
		fetchSoftwareDocument();
	});

	return (
		<ComponentInfo name="AccountSelectorPlaceholder">
			{companyAccounts && <AccountSelector companyAccounts={companyAccounts} />}
		</ComponentInfo>
	);
};
